import { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router';

import { SplashScreen } from 'src/components/loading-screen';
import { useAuthContext } from '../hooks';

type RoleGuardProps = {
  children?: React.ReactNode;
  allowedRoles: string[];
  /** strumento riservato: un Consulente entra solo se il server glielo ha abilitato (user.strumentiRiservati) */
  strumento?: string;
  /** risorsa governata dalle regole di visibilita', es. "menu:articoli": un Consulente entra solo se la vede (user.risorseVisibili) */
  risorsa?: string;
};

export function RoleGuard({ children, allowedRoles, strumento, risorsa }: RoleGuardProps) {
  const { user, loading, authenticated } = useAuthContext();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    if (loading) return;
    setIsChecking(false);
  }, [loading, authenticated, user]);

  if (isChecking || loading) {
    return <SplashScreen />;
  }

  if (!authenticated) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  const userRole = user?.role; // oppure user?.ruolo

  if (!userRole || !allowedRoles.includes(userRole)) {
    return <Navigate to="/404" replace />;
  }

  if (strumento && userRole === 'Consulente' && !user?.strumentiRiservati?.includes(strumento)) {
    return <Navigate to="/404" replace />;
  }

  if (risorsa && userRole === 'Consulente' && !user?.risorseVisibili?.includes(risorsa)) {
    return <Navigate to="/404" replace />;
  }

  if (children) {
    return <>{children}</>;
  }

  return <Outlet />;
}
